import { render, staticRenderFns } from "./betaDown.vue?vue&type=template&id=a19c6ce0&"
import script from "./betaDown.vue?vue&type=script&lang=js&"
export * from "./betaDown.vue?vue&type=script&lang=js&"
import style0 from "./betaDown.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports